<template>
  <div :style="settingsStore.colorSetup" :key="activeInstitutionId" class="webkit-fill-fix">
    <template v-if="amILoggedIn">
      <div class="flex flex-col h-screen border-box">
        <TopPanel class="absolute inset-x-0 top-0 h-16 md:h-24" />

        <div class="flex-grow flex pt-16 md:pt-24 webkit-fill-fix">
          <LeftPanel />
          <main class="flex-grow p-4 md:p-8 overflow-auto pb-20 md:pb-4" v-if="!isLoading">
            <router-view />
          </main>
        </div>
      </div>
      <transition name="fade">
        <div id="preloader" v-if="isLoading" class="flex items-center justify-center">
          <InfoSpinner></InfoSpinner>
        </div>
      </transition>
      <GlobalSnackbar></GlobalSnackbar>
    </template>

    <template v-if="!amILoggedIn">
      <div class="flex h-screen border-box justify-center items-center bg-gray-100">
        <div class="bg-white border-gray-200 border w-1/2 text-center p-12 rounded-lg">
          <h2 class="text-20 text-black-60% font-semibold">
            {{ customerSystemName ? $t("Home.YouHaveBeenLoggedOutOf") : $t("Home.YouHaveBeenLoggedOut") }}
            {{ customerSystemName }}
          </h2>

          <img v-if="customerSystemLogo" :src="customerSystemLogo" class="mt-8 mx-auto h-20" />

          <div class="text-sm mt-8">
            <a :href="kvikloginUrl" class="underline">{{ $t("Home.LoginAgain") }}</a>
          </div>
        </div>

        <img src="https://assets.nordiccloud.dk/logos/nct/NordicCloudTransparent.png" class="fixed bottom-14px w-40" />
      </div>
    </template>
  </div>
</template>

<script>
import apiSkobo from "@/helpers/api/apiSkobo";
import msalConnection from "@/helpers/api/msalConnection";

import store from "@/helpers/store";

import { useSettingsStore } from "@/stores/settings";
import { useInstitutionsStore } from "@/stores/institutions";
import { CookieHelper } from "@/helpers/utilities/CookieHelper";
import { SessionHelper } from "@/helpers/utilities/sessionHelper";

import LeftPanel from "@/components/Navigation/LeftPanel";
import TopPanel from "@/components/Navigation/TopPanel";
import GlobalSnackbar from "@/components/Shared/GlobalSnackbar";
import InfoSpinner from "@/components/Shared/InfoSpinner";

export default {
  name: "nwpApp",
  store,

  data: function () {
    return {
      isLoading: true,
      amILoggedIn: !!SessionHelper.nctSessionToken()
    };
  },

  setup() {
    return {
      settingsStore: useSettingsStore(),
      institutionsStore: useInstitutionsStore()
    };
  },

  computed: {
    activeInstitutionId() {
      return this.institutionsStore.myActiveInstitutionId || "noinst";
    },

    kvikloginUrl() {
      return import.meta.env.VITE_APP_NCT_LOGIN_ENDPOINT
        ? import.meta.env.VITE_APP_NCT_LOGIN_ENDPOINT
        : "https://kviklogin.dk";
    },

    customerSystemName() {
      return SessionHelper.customerSystemName;
    },

    customerSystemLogo() {
      return SessionHelper.customerSystemLogo;
    }
  },

  async mounted() {
    if (this.amILoggedIn) {
      this.isLoading = true;

      // this.$store.dispatch("settings/loadUserSettings", this.$skoboUser.userId);

      await this.loadApplicationSetup();
      await this.setInitialInstitution();
      await this.setupMSAL();

      this.checkForRedirectPath();
      this.isLoading = false;

      SessionHelper.onLogout(() => {
        this.amILoggedIn = false;
      });
    }
  },

  methods: {
    async loadApplicationSetup() {
      const result = await apiSkobo.get("/me/setup");
      const setupObject = result.data;

      const settingsStore = useSettingsStore();
      await settingsStore.loadSetup(setupObject);
    },

    async setInitialInstitution() {
      const institutionsStore = useInstitutionsStore();
      await institutionsStore.setActiveInstitutionFromToken();
    },

    async setupMSAL() {
      const settingsStore = useSettingsStore();
      await msalConnection.init(settingsStore.interfaces.tenant, settingsStore.interfaces.graphAPIClientId);
    },

    checkForRedirectPath() {
      const pathForLoad = CookieHelper.getCookieForNextBrowserLoad();
      if (pathForLoad) {
        CookieHelper.deleteCookieForNextBrowserLoad();
        this.$router.push({ path: pathForLoad });
      }
    }
  },

  components: {
    LeftPanel,
    TopPanel,
    GlobalSnackbar,
    InfoSpinner
  }
};
</script>
